"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CONTACTS_EVENTS = void 0;
exports.CONTACTS_EVENTS = {
  PRINT_ANNOUNCEMENTS: 'User printed an announcement to notify owners'
};